import { ICloudbase } from '@cloudbase/types'
import { ICloudbaseComponent } from '@cloudbase/types/component'
import { ICallFunctionOptions } from '@cloudbase/types/functions'
import { constants } from '@cloudbase/utilities'

declare const cloudbase: ICloudbase

const { ERRORS } = constants

const COMPONENT_NAME = 'cloudrun'

class CloudbaseRun {
  public async callContainer(options: ICallFunctionOptions) {
    const { name, data } = options

    if (!name) {
      throw new Error(JSON.stringify({
        code: ERRORS.INVALID_PARAMS,
        msg: `[${COMPONENT_NAME}.callContainer] invalid name`,
      }),)
    }
    let jsonData
    try {
      jsonData = data ? JSON.stringify(data) : ''
    } catch (e) {
      throw new Error(JSON.stringify({
        code: ERRORS.INVALID_PARAMS,
        msg: `[${COMPONENT_NAME}.callContainer] invalid data`,
      }),)
    }

    return await requestContainer.call(this, { ...options, data: jsonData })
  }
}

export async function requestContainer(this: any, options: ICallFunctionOptions) {
  const { name, data, path = '', method, header = {} } = options
  const endpoint = `https://${this.config.env}.api.tcloudbasegateway.com/v1/cloudrun/${name}`
  const reqPath = path.startsWith('/') ? path : `/${path}`
  // @ts-ignore
  const response = await this.request.fetch({
    method: method || 'POST',
    headers: Object.assign(
      {},
      {
        'Content-Type': 'application/json; charset=utf-8',
      },
      header,
    ),
    body: data,
    url: `${endpoint}${reqPath}`,
  })

  return await response.data
}

const cloudbaseRun = new CloudbaseRun()

const component: ICloudbaseComponent = {
  name: COMPONENT_NAME,
  entity: {
    callContainer: cloudbaseRun.callContainer,
  },
}
try {
  cloudbase.registerComponent(component)
} catch (e) {}

export function registerCloudrun(app: Pick<ICloudbase, 'registerComponent'>) {
  try {
    app.registerComponent(component)
  } catch (e) {
    console.warn(e)
  }
}
